import { Component } from 'react';
import PropTypes from 'prop-types';
import OutlinedTextField from '../textFields/OutlinedTextField';
import Wrapper from '../Wrapper';
import * as baseStyles from '../../../styles/baseStyles.module.scss';
import * as formStyles from '../styles/styles.module.scss';
import { validateUserForm, hasErrors } from '../../../utils/UserFormHelper';
import { ServerCommunicationUtil } from '../../../utils/server_communication_util';
import { LanguageSupportUtil } from '../../../utils/language_support_util';
import FormButton from '../FormButton';
import Button from '@alltrails/shared/denali/components/Button';
import { FormattedMessage } from 'react-intl';

class ForgotPasswordForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      forgotPasswordEmail: '',
      submitting: false,
      showErrorsOnType: false,
      errors: {
        forgotPasswordEmail: ''
      },
      serverError: null
    };
  }

  static LOGIN_PAGE_URL = '/login';

  failedFormValidation() {
    let validationErrors = { ...this.state.errors };
    let validation;
    for (const name in this.state.errors) {
      validation = validateUserForm(name, this.state[name], validationErrors);
      validationErrors = { ...validationErrors, ...validation.errors };
    }

    this.setState({ errors: validationErrors });
    return hasErrors(validationErrors);
  }

  // handlers

  handleChange = e => {
    e.preventDefault();
    const { name, value } = e.target;
    if (this.state.showErrorsOnType) {
      const errors = validateUserForm(name, value, { ...this.state.errors });
      this.setState({ ...errors, [name]: value });
    } else {
      this.setState({ [name]: value });
    }
  };

  handleSuccess = res => {
    window.location.href = LanguageSupportUtil.wrapUrlSafe(res.redirectUrl, this.props.locale);
  };

  handleError = res => {
    if (!res.responseJSON || !res.responseJSON.errors) {
      this.setState({ submitting: false });
      return;
    }

    this.setState({ serverError: res.responseJSON.errors.join(', '), submitting: false });
  };

  handleComplete = () => {};

  handleSubmit = e => {
    e.preventDefault();

    if (this.state.submitting) {
      return;
    }

    if (this.failedFormValidation()) {
      this.setState({ showErrorsOnType: true });
      return;
    }

    this.setState({ submitting: true });
    const headers = this.props.locale ? { 'X-Language-Locale': this.props.locale } : {};
    const params = {
      [this.props.resourceName]: {
        login: this.state.forgotPasswordEmail
      }
    };

    ServerCommunicationUtil.postApiEndpoint(this.props.forgotPasswordUrl, params, this.handleSuccess, this.handleError, this.handleComplete, headers);
  };

  renderEmailInput() {
    return (
      <div className={formStyles.inputItem}>
        <OutlinedTextField
          name="forgotPasswordEmail"
          errorMessage={this.state.errors.forgotPasswordEmail}
          value={this.state.forgotPasswordEmail}
          label={<FormattedMessage defaultMessage="Email" />}
          changeHandler={this.handleChange}
          enterKeyHandler={this.handleSubmit}
          type="email"
        />
      </div>
    );
  }

  renderServerError() {
    return <div className={formStyles.serverError}>{this.state.serverError}</div>;
  }

  renderErrorsAndSubmit() {
    return (
      <div className={`${formStyles.inputItemSmall}`}>
        {this.renderServerError()}
        <FormButton disabled={this.state.submitting} value={<FormattedMessage defaultMessage="Send email" />} />
      </div>
    );
  }

  renderForm() {
    return (
      <form onSubmit={this.handleSubmit}>
        {this.renderEmailInput()}
        {this.renderErrorsAndSubmit()}
      </form>
    );
  }

  render() {
    return (
      <Wrapper
        text={{
          stepText: <FormattedMessage defaultMessage="Enter your email to get help logging in." />,
          headText: <FormattedMessage defaultMessage="Forgot your password?" />
        }}
        foot={
          <FormattedMessage
            defaultMessage={`Note: The password reset email may take a few minutes. If you don't see it then, please check your "Promotions" tab and spam folder. If you are resubmitting this form, please note that any previous password reset emails you have requested will not work.`}
          />
        }
        showStepText
      >
        <div className={baseStyles.section}>
          {this.renderForm()}
          <Button
            text={<FormattedMessage defaultMessage="Back to sign in" />}
            linkInfo={{ href: LanguageSupportUtil.wrapUrlSafe(ForgotPasswordForm.LOGIN_PAGE_URL, this.props.locale) }}
            onClick={() => {
              /* do nothing */
            }}
            testId="forgot-password-back-to-sign-in"
            variant="flat"
            width="full"
          />
        </div>
      </Wrapper>
    );
  }
}

ForgotPasswordForm.propTypes = {
  locale: PropTypes.string,
  resourceName: PropTypes.string,
  forgotPasswordUrl: PropTypes.string
};

export default ForgotPasswordForm;
